// components/FadeInWhenVisible.jsx
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function FadeInWhenVisible({ children, delay = 0, direction = 'up' }) {
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

    const variants = {
        hidden: {
            opacity: 0,
            y: direction === 'up' ? 40 : direction === 'down' ? -40 : 0,
            x: direction === 'left' ? 40 : direction === 'right' ? -40 : 0,
        },
        visible: {
            opacity: 1,
            y: 0,
            x: 0,
            transition: { duration: 0.6, delay },
        },
    };

    return (
        <motion.div
            ref={ref}
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            variants={variants}
        >
            {children}
        </motion.div>
    );
}
